import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {AppClipsInterface} from '../../interfaces/app-clips.interface';
import {ApiService} from '../../service/api.service';
import {environment} from '../../../environments/environment';

@Component({
  selector: 'app-app-clips',
  templateUrl: './app-clips.component.html',
  styleUrls: ['./app-clips.component.sass']
})
export class AppClipsComponent implements OnInit, OnDestroy {
  public dashboardUrl = environment.dashboardUrl;

  public buildingsGroupId;
  public building: AppClipsInterface;
  public apartments;
  public apartmentsArr = [];
  public currentPhotosArr = [];
  public buildingObj;

  private subscriptions: Subscription[] = [];

  constructor(
    private service: ApiService,
    private router: Router,
    private activeRoute: ActivatedRoute
  ) {
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex';
    document.getElementsByTagName('head')[0].appendChild(meta);
  }

  ngOnInit() {
    this.buildingsGroupId = this.activeRoute.snapshot.params.id;
    this.subscriptions.push(
      this.service.getAppClipsBuildingOld(this.buildingsGroupId).subscribe(building => {
        if (building) {
          this.buildingObj = building;
          if (this.buildingObj.building === null) {
            this.router.navigate(['/']);
          } else {
            this.building = this.buildingObj.building;
          }
        } else {
          this.router.navigate(['/']);
        }
      }, error => {
        if (error) {
          this.router.navigate(['/']);
        }
      })
    );
    this.subscriptions.push(
      this.service.getAppClipsApartmentsOld(this.buildingsGroupId).subscribe((apartment) => {
        if (apartment) {
          this.apartments = apartment;
          //  this.apartmentsArr = this.apartments.apartments;
          this.apartmentsArr = this.apartments.apartments.filter(item => !item.isHidden);
          this.apartmentsArr.forEach(item => {
            item.checkedIndex = 0;
            this.currentPhotosArr.push(item.photos[0]);
          });
        }
      })
    );

  }

  public changePhoto(apartmentIndex, photoIndex) {
    this.apartmentsArr[apartmentIndex].checkedIndex = photoIndex;
    this.currentPhotosArr[apartmentIndex] = this.apartmentsArr[apartmentIndex].photos[photoIndex];
  }

  public nextPhoto(apartmentIndex) {
    this.apartmentsArr[apartmentIndex].checkedIndex = this.apartmentsArr[apartmentIndex].checkedIndex + 1;
    if (this.apartmentsArr[apartmentIndex].checkedIndex === this.apartmentsArr[apartmentIndex].photos.length) {
      this.apartmentsArr[apartmentIndex].checkedIndex = 0;
    }
    this.currentPhotosArr[apartmentIndex] = this.apartmentsArr[apartmentIndex].photos[this.apartmentsArr[apartmentIndex].checkedIndex];
  }

  public prevPhoto(apartmentIndex) {
    if (this.apartmentsArr[apartmentIndex].checkedIndex === 0) {
      this.apartmentsArr[apartmentIndex].checkedIndex = this.apartmentsArr[apartmentIndex].photos.length;
    }
    this.apartmentsArr[apartmentIndex].checkedIndex = this.apartmentsArr[apartmentIndex].checkedIndex - 1;
    this.currentPhotosArr[apartmentIndex] = this.apartmentsArr[apartmentIndex].photos[this.apartmentsArr[apartmentIndex].checkedIndex];
  }

  public selfTour(branchioLink) {
    if (branchioLink) {
      window.location.href = branchioLink;
    }
  }

  public mailToAgent(email) {
    if (email) {
      window.location.href = `mailto:${email}`;
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(e => e.unsubscribe());
  }

  trackByApId(index, item) {
    return item.apartmentId || index;
  }

  trackByIndex(index) {
    return index;
  }
}
